import { ref } from 'vue'
import { recruitmentTagApi } from '@/services/api'

export const useInfiniteRecruitmentTagApi = ({ value = ref(), limit = ref(30), page = ref(0) }) => {
  const list = ref([])
  const haveMore = ref(true)
  const loading = ref(false)
  const select = (selected) => {
    value.value = selected
  }
  const getMoreData = async (options = {}) => {
    if (options.new) {
      page.value = 0
      haveMore.value = true
    }
    loading.value = true
    const tagRequest = await recruitmentTagApi.filter({ page: page.value, limit: limit.value, search: options.search }).promise
    loading.value = false
    list.value = options.new ? tagRequest.docs : [...list.value, ...tagRequest.docs]
    haveMore.value = tagRequest.count?.currentPage < tagRequest.count?.totalPages
    page.value++
  }

  const remove = (toRemove) => {
    value.value = undefined
  }

  return {
    haveMore,
    getMoreData,
    remove,
    select,
    list,
    loading,
    value,
  }
}

export const useInfinityRecruitmentTag = ({ search = ref(''), limit = ref(20), page = ref(0), isLoading = ref(false), list = ref([]) }) => {
  const haveMore = ref(true)

  const getMoreData = async () => {
    try {
      isLoading.value = true
      const response = await recruitmentTagApi.filter({ search: search.value, limit: limit.value, page: page.value }).promise

      haveMore.value = response.count?.currentPage < response.count?.totalPages

      list.value = page.value === 0
        ? response.docs
        : [...list.value, ...response.docs]

      return response
    }
    catch (err) {
      console.log('err', err)
    }
    finally {
      isLoading.value = false
    }
  }

  return { search, limit, page, haveMore, getMoreData, list, isLoading }
}
